module.exports = __webpack_public_path__ + "files/b080c799a19f39245daf96b204659337.png";